/**
 * 微前端配置文件
 */

const microAppMark = '/sub';

/**
 * 子应用配置
 * @param name 子应用名称 与子应用 package.json 中的 name 保持一致
 * @param activeRule 域名标识
 * @param port 开发本地端口号 备注：如发现404，可能端口被占用，建议查询后重新启动项目
 */
const microAppList = [
  // 基础服务
  {
    name: 'microAppBase',
    activeRule: '/base/',
    port: '3071',
    project: 'bu_pc_base',
  },
  // 交易 订单
  {
    name: 'microAppGoodManager',
    activeRule: '/goodManager/',
    port: '3075',
    project: 'bu_pc_trade',
  },
  // 商端
  {
    name: 'microAppMerchant',
    activeRule: '/merchant/',
    port: '3076',
    project: 'bu_pc_merchant',
  },
  // 调度 物流
  {
    name: 'microAppDispatch',
    activeRule: '/dispatch/',
    port: '3077',
    project: 'bu_pc_dispatch',
  },
  // 财务
  {
    name: 'microAppSettlement',
    activeRule: '/settlement/',
    port: '3078',
    project: 'bu_pc_settlement',
  },
  {
    name: 'microAppOperation',
    activeRule: '/operation/',
    port: '3099',
    project: '',
  },
  // 客crm
  {
    name: 'microAppCrm',
    activeRule: '/crm/',
    port: '3000',
    project: 'bu_pc_crm',
  },
  // 大客crm
  {
    name: 'microAppCcrm',
    activeRule: '/ccrm/',
    port: '3003',
    project: 'bu_pc_ccrm',
  },
  // diting
  {
    name: 'microAppDiting',
    activeRule: '/diting/',
    port: '3001',
    project: 'bu_pc_diting',
  },
  // JT-流程引擎
  {
    name: 'microAppProcess',
    activeRule: '/process/',
    port: '3092',
    project: 'infra-web-workflow',
  },
  // zigongcheng
  {
    name: 'microAppPublic',
    activeRule: '/public/',
    port: '5000',
    project: 'infra-web-cli',
  },
  // JT-统一权限
  {
    name: 'microAppPublicAuthority',
    activeRule: '/publicAuthority/',
    port: '3091',
    project: 'infra-web-authority',
  },
  // 自营-服务
  {
    name: 'microAppScmService',
    activeRule: '/scmService/',
    port: '3050',
    project: 'scm_pc_service',
  },
  // 自营-物流
  {
    name: 'microAppScmLogistics',
    activeRule: '/scmLogistics/',
    port: '3051',
    project: 'scm_pc_logistics',
  },
  // 自营-交易
  {
    name: 'microAppScmTrade',
    activeRule: '/scmTrade/',
    port: '3052',
    project: 'unknown',
    deprecated: true,
  },
  // 自营-资产
  {
    name: 'microAppScmCapital',
    activeRule: '/scmCapital/',
    port: '3053',
    project: 'scm_pc_capital',
  },
  // 自营-交付
  {
    name: 'microAppScmDeliver',
    activeRule: '/scmDeliver/',
    port: '3054',
    project: 'scm_pc_deliver',
  },
  // 开工啦
  {
    name: 'microAppDeviceCenter',
    activeRule: '/deviceCenter/',
    port: '3100',
    project: 'merchant_device_center',
  },
  // 客端saas
  {
    name: 'microAppCustomerSaas',
    activeRule: '/customerSaas/',
    port: '4000',
    project: 'customer_saas_pc',
  },
  // ccs 线索中台
  {
    name: 'microAppCcs',
    activeRule: '/ccs/',
    port: '3002',
    project: 'bu_pc_clue',
  },
  // 商端crm
  {
    name: 'microAppMerchantCrm',
    activeRule: '/merchantCrm/',
    port: '3080',
    project: 'merchant_crm_pc',
  },
  // 信息化-财务相关
  {
    name: 'microAppFinancial',
    activeRule: '/baseFinancial/',
    port: '3083',
    project: 'infra-web-financial',
  },
  // 低码可视化
  {
    name: 'microApaasBuilder',
    activeRule: '/apaas_builder/',
    port: '3168',
    project: 'apaas_builder',
  },
   // JT-统一消息
   {
    name: 'microAppPublicMessage',
    activeRule: '/publicMessage/',
    port: '3093',
    project: 'infra-web-message',
  },
  // 呼叫中心
  {
    name: 'microAppCall',
    activeRule: '/call/',
    port: '3081',
    project: 'bu_pc_call',
  },
  // 电销工作台
  {
    name: 'microAppTelemarketing',
    activeRule: '/telemarketing/',
    port: '3098',
    project: 'bu_pc_telemarketing',
  },
  // 金融工作台
  {
    name: 'microAppScFinance',
    activeRule: '/scFinance/',
    port: '3082',
    project: 'bu_pc_scfinance',
  },
  // 委外律师端子工程
  {
    name: 'microAppThemis',
    activeRule: '/themis/',
    port: '3101',
    project: 'bu_pc_themis',
  },
  // 客服工作台
  {
    name: 'microAppCustomerService',
    activeRule: '/customerService/',
    port: '3102',
    project: 'bu_pc_csd',
  },
  {
    name: 'microAppScmMainLogistics',
    activeRule: '/scmMainLogistics/',
    port: '3055',
    project: 'scm_pc_main_logistics',
  },
  // 元数据
  {
    name: 'microAppPublicMetadata',
    activeRule: '/publicMetadata/',
    port: '3089',
    project: 'infra-web-metadata',
  },
  // 商品，类目，价格，品牌等
  {
    name: 'microAppProductInfohub',
    activeRule: '/productInfohub/',
    port: '3120',
    project: 'bu_pc_productInfohub',
  },
  // console后台
  {
    name: 'microAppConsole',
    activeRule: '/console/',
    port: '3094',
    project: 'infra-web-console',
  },
  // admin后台（雏鹰权限）
  {
    name: 'microAppAdmin',
    activeRule: '/admin/',
    port: '3095',
    project: 'infra-web-admin',
  },
  // 履约
  {
    name: 'microAppDelivery',
    activeRule: '/delivery/',
    port: '3123',
    project: 'bu_pc_delivery',
  },
  // 资方设备
  {
    name: 'microAppScmInvestor',
    activeRule: '/scmInvestor/',
    port: '3056',
    project: 'scm_pc_investor',
  },
  {
    name: 'microAppCenterApaas',
    activeRule: '/centerApaas/',
    port: '3124',
    project: 'bu_pc_center_apaas',
  },
  {
    name: 'microAppCustomerCenter',
    activeRule: '/customerCenter/',
    port: '4090',
    project: 'bu_pc_customer_center',
  },
  {
    name: 'microAppMarketing',
    activeRule: '/marketing/',
    port: '3125',
    project: 'bu_pc_marketing',
  },
  {
    name: 'microAppContract',
    activeRule: '/contract/',
    port: '3126',
    project: 'bu_pc_contract',
  },
  {
    name: 'microAppZMS',
    activeRule: '/zms/',
    port: '4100',
    project: 'unknown',
    deprecated: true,
  },
];

export {
  microAppList,
  microAppMark,
};
